export { KmapBinomialCoefficient } from './KmapBinomialCoefficient';
